import React from 'react';
import { useWebContents } from '../../hooks/useWebContents';
import CompostOptionGrid from '../../customized/CompostOptions';
import { useImages } from '../../hooks/useImages';

const GUIDS = {
  compostYes: '7ca30701-e834-4b34-bf79-bba4a14bcfd5',
  compostNo: 'fc819c90-b09e-4cd0-aa41-566edbceb68c',
};

const CompostYesGUIDS = {
  meat: '3096ead2-96d5-4fcf-9d36-58aefdc822b1',
  yardWaste: '6165b468-6792-4e71-be58-fd6092d25991',
  dairy: '69518713-d26a-492e-9b1f-802603ebef87',
  coffee: '1e119424-ffc0-4f04-9f9a-b2e69faad5f5',
  leftovers: '5394ca9c-54c8-4732-94f3-c42d5577d5a4',
};

const CompostNoGUIDS = {
  bones: '69ebea78-583a-482e-969c-6ac8eeb5c325',
  commercial: 'bfa0aa38-14a1-41d5-9cb5-393cd62be701',
  petWaste: '5fc9f315-4c04-4814-b381-20bff3a31414',
};

const CompostOptions: React.FC = () => {
  const contents = useWebContents(GUIDS, 'HomeCompost');
  const compostYesContent = useWebContents(CompostYesGUIDS, 'HomeCompostYES');
  const compostNoContent = useWebContents(CompostNoGUIDS, 'HomeCompostNO');

  const leftoversImage = useImages(CompostYesGUIDS.leftovers)?.image;
  const coffeeImage = useImages(CompostYesGUIDS.coffee)?.image;
  const dairyImage = useImages(CompostYesGUIDS.dairy)?.image;
  const yardWasteImage = useImages(CompostYesGUIDS.yardWaste)?.image;
  const meatImage = useImages(CompostYesGUIDS.meat)?.image;

  const petWasteImage = useImages(CompostNoGUIDS.petWaste)?.image;
  const commercialImage = useImages(CompostNoGUIDS.commercial)?.image;
  const bonesImage = useImages(CompostNoGUIDS.bones)?.image;

  // Example image data. Replace with your actual image filenames and labels.
  const compostYesOptions = [
    { img: leftoversImage ?? '', label: compostYesContent.leftovers.heading, description: compostYesContent.leftovers.content },
    { img: coffeeImage ?? '', label: compostYesContent.coffee.heading, description: compostYesContent.coffee.content },
    { img: dairyImage ?? '', label: compostYesContent.dairy.heading, description: compostYesContent.dairy.content },
    { img: yardWasteImage ?? '', label: compostYesContent.yardWaste.heading, description: compostYesContent.yardWaste.content },
    { img: meatImage ?? '', label: compostYesContent.meat.heading, description: compostYesContent.meat.content },
  ];
  //make sure you are case sesistive with your image names and paths
  const compostNoOptions = [
    { img: petWasteImage ?? '', label: compostNoContent.petWaste.heading, description: compostNoContent.petWaste.content },
    { img: commercialImage ?? '', label: compostNoContent.commercial.heading, description: compostNoContent.commercial.content },
    { img: bonesImage ?? '', label: compostNoContent.bones.heading, description:  compostNoContent.bones.content },
  ]

  return (
    <section className="w-full bg-[#f5f5e6] py-12 flex flex-col items-center px-4">
      <h2 className="text-3xl md:text-4xl font-bold text-[#AE582D] mb-4 uppercase tracking-wide  text-center">
        {contents.compostYes.heading}
      </h2>
      <div className="w-20 h-1 bg-[#1a3a1a] rounded mb-8" />
      <CompostOptionGrid
        content={contents.compostYes.content}
        options={compostYesOptions}
      />
      <br></br> <br></br>
      <CompostOptionGrid
        content={contents.compostNo.content}
        options={compostNoOptions}
      />
    </section>
  )
};

export default CompostOptions;